import React, { FC } from 'react';
import { languages } from '@src/i18n';
import useActiveLanguage from '@src/shared/hooks/use-active-language';
import { IconButton } from '@material-ui/core';

interface ILanguageSelectorProps {
  toggleButtonClass?: string;
  showToggleButton?: boolean;
  onClick?: () => void;
}

export const LanguageSelector: FC<ILanguageSelectorProps> = ({
  toggleButtonClass,
  showToggleButton = true,
  onClick,
}) => {
  const { storedLanguageCode } = useActiveLanguage(true);

  return (
    <>
      {showToggleButton ? (
        <IconButton
          classes={{ root: toggleButtonClass || '' }}
          size="medium"
          aria-label="Toggle menu"
          onClick={onClick}
        >
          <img
            src={languages[storedLanguageCode as string].img}
            alt="Toggle menu"
          />
        </IconButton>
      ) : null}
    </>
  );
};

export default LanguageSelector;
